import { useEffect } from "react";
import { usePillarTableContext } from "shared/components/pillar-table/PillarTableContext";
import {
  type FiltersRequest,
  type FilterRequestTypes,
} from "shared/filter-where-clause";

export const usePillarTableFilterState = <
  FilterValueType extends FilterRequestTypes,
>(filterState?: {
  filterKey?: string;
  defaultValue?: FilterValueType;
}) => {
  const { setFilters, filtersRequest } = usePillarTableContext();

  const updateCurrentFilter = (
    updater: FilterValueType | ((prevValues: FiltersRequest) => FiltersRequest),
  ) => {
    if (typeof updater === "function") {
      setFilters(updater(filtersRequest));
      return;
    }

    if (filterState?.filterKey) {
      setFilters({ ...filtersRequest, [filterState.filterKey]: updater });
    }
  };

  useEffect(() => {
    if (filterState?.defaultValue) {
      updateCurrentFilter(filterState.defaultValue);
    }
  }, [filterState?.defaultValue]);

  const rawFilterValue = filterState?.filterKey
    ? filtersRequest[filterState.filterKey]
    : undefined;

  const filterValue = rawFilterValue as FilterValueType | undefined;

  return {
    filterValue,
    filters: filtersRequest,
    setFilterValue: updateCurrentFilter,
  };
};
